"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomOption = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// TODO: add support for secondary description and icon
var CustomOption = function CustomOption(_ref) {
  var className = _ref.className,
    children = _ref.children,
    description = _ref.description,
    icon = _ref.icon,
    disabled = _ref.disabled,
    isHighlighted = _ref.isHighlighted,
    isSelected = _ref.isSelected,
    highlightedRef = _ref.highlightedRef,
    onMouseDown = _ref.onMouseDown;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('flex px-[24px] py-[11px] text-grey-75 hover:bg-green1-15', {
      'bg-green1-15': isHighlighted
    }, {
      'bg-grey-20': isSelected
    }, {
      'flex-col': !icon
    }, isSelected ? 'tw-body-sm-medium' : 'tw-body-sm-light', disabled ? 'cursor-not-allowed pointer-events-none' : 'cursor-pointer select-none', className),
    onMouseDown: onMouseDown,
    onTouchStart: onMouseDown,
    ref: isHighlighted ? highlightedRef : null
  }, /*#__PURE__*/_react.default.createElement("span", null, children), description);
};
exports.CustomOption = CustomOption;